import {useInfiniteQuery} from 'react-query';
import {getMyWanteds} from 'services/myAd/myWanted';

interface GetMyWantedParams {
  profile_type: 'farmer' | 'market';
}
const useGetMyWanted = (params: GetMyWantedParams) => {
  const {
    data: MyWanteds,
    isLoading,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery(
    ['MyWanteds', params.profile_type],
    ({pageParam = 1, queryKey}) => getMyWanteds(pageParam, queryKey[1]),
    {
      getNextPageParam: (lastPage, allPages) => {
        const lastRecord = allPages[allPages.length - 1]?.next || '';
        return lastRecord
          ? new URL(lastRecord).searchParams.get('page')
          : undefined;
      },
    },
  );
  return {MyWanteds, isLoading, refetch, fetchNextPage};
};

export default useGetMyWanted;
